export class PolicyPayment {

    constructor(
      public InvoiceNumber: string,
      public PaymentReferenceNumber: string,
      public LastBilledAmount: string,
      public PaymentAmount: string,
      public LastBilledAmtDate: Date
    ) {}
}
